import type { TextureAppearance } from 'src/modules/designStudio/helpers/data/TemplateDesignConfig';
import { createRealProductColor } from 'src/modules/designStudio/helpers/productSelection/ProductDataStore';
import type { VariationColorGroup } from 'src/modules/designStudio/helpers/productSelection/types';

export const getTexturedAppearanceColorGroup = (
  appearance: TextureAppearance,
): VariationColorGroup | undefined =>
  appearance.color
    ? createRealProductColor({
        name: '',
        hex: appearance.color,
      }).group
    : undefined;
